export enum ETrackingEventType {
  PROFILE_COMPLETED = 'PROFILE_COMPLETED',
  LIVE_CLASS_ADDED = 'LIVE_CLASS_ADDED',
  INTRODUCTION_COMPLETED = 'INTRODUCTION_COMPLETED',
  PLANIFICATION_ACTIVITY_COMPLETED = 'PLANIFICATION_ACTIVITY_COMPLETED',
  QUIZ_COMPLETED = 'QUIZ_COMPLETED',
  ACTIVITY_COMPLETED = 'ACTIVITY_COMPLETED'
}
